// extracted by mini-css-extract-plugin
export default {"root":"FavouriteButton-root","text":"FavouriteButton-text"};